import en from './en';
import cs from './cs';

// Note messages for all languages are imported all at once. That's fine for
// almost all apps. If gzipped messages dir is bigger then say 20 kB, congrats!
// Your app is used and usefull, so now it's time for futher optimization. Since
// messages are in app state, they can be fetched or passed from server easily.

export default {en, cs};



// WEBPACK FOOTER //
// ./src/common/intl/messages/index.js